$(function () {
  if($('.auth-pages-layout').length ===0) return;

  $('.mobile-menu-toggle').click(function () {
    $('header').toggleClass('mobile-menu-expanded');

    const icon = $(this).find('svg');
    const isExpanded = $('header').hasClass('mobile-menu-expanded');
    isExpanded ? icon.removeClass('fa-bars').addClass('fa-xmark') : icon.removeClass('fa-xmark').addClass('fa-bars');
  });

  $('header .mobile-menu').click(function () {
    $('header').removeClass('mobile-menu-expanded');
    $('.mobile-menu-toggle').find('svg').removeClass('fa-xmark').addClass('fa-bars');
  });

  $('header .mobile-menu .content').click(function (e) {
    e.stopPropagation();
  });

  $('form.forgot-password').validator().submit(function (e) {
    if (e.isDefaultPrevented()) return;
    let form = $(this);
    let data = form.serializeObject();

    let gRecaptcha='';
    gRecaptcha = data.gRecaptcha;
    delete data.gRecaptcha;


    request({
      loadingEl: $('.forgot-password').addClass('loading-mask'),
      url: '/users/forgot-password',
      method:'POST',
      data: data,
      headers:{
        gRecaptcha:gRecaptcha
      },
      preventDefaultError: true,
      onError: function(errors) {
        gRecaptchaReset();
        $.each(errors, function(k, error) {
          Validation.displayError(error.field, error.message);
        });
      },
      callback: function (r) {
        form.find('[name="email"]').closest('.form-group').hide().next().hide().next().hide();
        form.find('.msg').text('Password reset instructions successfully sent to your email.');
      }
    });
  });

  $('form.reset-password').validator(Validation.customRules).submit(function (e) {
    if (e.isDefaultPrevented()) return;
    let form = $(this);
    let data = form.serializeObject();

    data.token = getParam('token');
    let gRecaptcha='';
    gRecaptcha = data.gRecaptcha;
    delete data.gRecaptcha;

    if (data.password_confirmation !== data.password) {
      return Validation.displayError('password_confirmation', 'Passwords do not match');
    }

    request({
      loadingEl: $('.reset-password').addClass('loading-mask'),
      url: '/users/reset-password',
      method:'POST',
      data: data,
      headers:{
        gRecaptcha:gRecaptcha
      },
      callback: function (r) {
        window.location.href = "/login?afterReset=1";
      },
      preventDefaultError: true,
      onError: function (errors) {
        errors[0].field = 'password';
        gRecaptchaReset();
        $.each(errors, function (k, error) {
          Validation.displayError(error.field, error.message);
        });
      }
    });
  });

  let error = getParam('error');
  if (error === 'undefined') {
    Modal.show({
      html: "Invalid credentials",
      no: "Close",
      withoutYes: true,
      without_no: true,
      onHide:function(){

      }
    });
  }

  const program  = getParam('program');
  const referral  = getParam('referral');

  const setReferral = ()=>{
    if(program && referral){
      setCookie('X-PROGRAM', program,365 );
      window.localStorage.setItem("referral", JSON.stringify({program:program,referral:referral}));
    }
  }

  const redirectFromPath = getParam('redirect');
  if(redirectFromPath){
    window.localStorage.setItem('destination', redirectFromPath);
    window.location.href = redirectFromPath;
  }

  $('.sign-in').submit(function () {
    let data = $(this).serializeObject();
    let username = data.username;
    let password = data.password;
    const loginLocation = window.location.pathname;
    request({
      loadingEl: $('.auth.sign-in').addClass('loading-mask'),
      url: loginUrl,
      method: 'POST',
      data: JSON.stringify({username: username, password: password}),
      contentType: 'application/json',
      callback: function (r) {

        if(r.errors){
          const errors = r.errors;
          $.each(errors, function (k, error) {
            Validation.displayError('alert', error.message);
          });
          return;
        }

        localStorage.setItem('loginLocation', loginLocation)
        setReferral();
        addTagManager({
          event:'account-login',
          action:'login',
          category:'account',
          label:getParam('utm_campaign')||''
        });

        window.localStorage.removeItem('sid');
        window.localStorage.removeItem('PreProgram');
       const programs =  {
          nfr:'/fundraiser/create-event/fundraiser',
          vfr:'/fundraiser/create-event/virtual',
          psl:'/school-lunch/create-order',
          rwm:'/read-with-me/create-enrollment',
          xlny:'/explore-lunar-new-year/create-order',
          paa:'/achievements-awards/create-order',
        }
      const program= getParam('program');
      const sid = getParam('sid');
      if(program && sid &&  Object.keys(programs).filter((i,k)=>i===program).length>0 && $.isNumeric(sid)){
        request({
          url:'/users/current',
          callback:function(user){
                if(user.group === 'guest'){
                  window.localStorage.setItem('sid',sid);
                  window.localStorage.setItem('PreProgram',program);
                  window.location.href = programs[program];
                } else window.location.href = "/entrypoint";
          }
        });
      }
      else window.location.href = "/entrypoint";
      },
      preventDefaultError: true,
      onError: function (errors) {
        $.each(errors, function (k, error) {
          Validation.displayError(error.field, error.message);
        });
      }
    });
  });


  function signUpPageActions(){
    clearInput($('#email,#password'));

    $('input[data-mask="phone"]').inputmask("999-999-9999");

    $('#password').blur(function () {
      let password = $(this).val();
    });

    const program  = getParam('program');
    const referral  = getParam('referral');
    if(program && referral){
      $('a[href="/login"]').attr({href:`/login?program=${program}&referral=${referral}`})
    }
    $('form.sign-up').validator(Validation.customRules).submit(function (e) {
      if (e.isDefaultPrevented()) return;

      let form = $(this);
      let data = form.serializeObject();
      data.phone = $(this).find('input[data-mask="phone"]').inputmask('unmaskedvalue');
      data.receiveLsmpNews = !!data.receiveLsmpNews;

      let gRecaptcha='';
      gRecaptcha = data.gRecaptcha;
      delete data.gRecaptcha;



      const setReferral = ()=>{
        if(program && referral){
          setCookie('X-PROGRAM', program,365 );
          window.localStorage.setItem("referral", JSON.stringify({program:program,referral:referral}));
        }
      }


      let visitor  = localStorage.getItem('visitor')
      if(visitor){
        visitor = JSON.parse(visitor)
        if(visitor.utm_source || visitor.utm_medium || visitor.utm_campaign){
          visitor.utm_source && (data.utmSource = visitor.utm_source)
          visitor.utm_medium && (data.utmMedium = visitor.utm_medium)
          visitor.utm_campaign && (data.utmCampaign = visitor.utm_campaign);
        }
      }

      if(getCookie('X-PROGRAM')) data.registrationSource = getCookie('X-PROGRAM');

      request({
        loadingEl: $('.sign-up').addClass('loading-mask'),
        contentType: 'application/json',
        method: 'POST',
        url: '/sign-up',
        headers:{
          gRecaptcha:gRecaptcha
        },
        data: JSON.stringify(data),
        callback: function (message) {
          setReferral();
          localStorage.removeItem('visitor');
          message+='<div>If you don’t receive an email within the next 24 hours, please <a href="/faq?contact-us=visible">Contact Us</a> and our representative will assist you as soon as possible.</div>'
          Modal.show({
            html: message,
            withoutYes: true,
            no: 'Log In',
            type: 'success',
            onHide:function(){
              window.location = '/login';
            }
          });
        },
        preventDefaultError: true,
        onError: function (errors) {
          gRecaptchaReset();
          if(errors && errors.length && errors[0].message === "An account already exists for this email address")
          {
            setReferral();
            Modal.show({
              html: "An account already exists for this email address! Please <a href='/login'>Log In</a>",
              withoutYes: true,
              no: 'Close',
              type: 'warning'
            });
          }
          else
            $.each(errors, function (k, error) {
              Validation.displayError(error.field, error.message);
            });
        }
      });
    });
  }

  function emailVerificationPageActions(){
    request({
      method: 'POST',
      url:'/users/emails/verifications/verify',
      data:{flow:getParam('flow'),code:getParam('code')},
      callback(){
        $('.success-text').show();
        addTagManager({
          event: 'account-created',
          action: 'created',
          category: 'account',
          label: getParam('utm_campaign') || ''
        });
      },
      preventDefaultError: true,
      onError: function (errors) {
        $('.error-text').show();
      }
    })
  }

  function forgotPasswordPageActions(){
    const isGuestLoginPage = localStorage.getItem("isGuestLoginPage");
    if(isGuestLoginPage !== null){
      $(".signIn-options").toggle(isGuestLoginPage === "true");
    }
  }

  if($('.sign-up-page-container').length) signUpPageActions();

  if($('.email-verification-page-container').length) emailVerificationPageActions();

  if($('.auth.forgot-password').length) forgotPasswordPageActions();
});
